import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnchor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAnchor1"><Path d="M17.75 11.75H21.25L19.1269 19.0842C18.7556 20.3671 17.5808 21.25 16.2453 21.25H12M6.25 11.75H2.75L4.87305 19.0842C5.24442 20.3671 6.41916 21.25 7.75474 21.25H12M12 21.25V8.25M12 8.25C13.5188 8.25 14.75 7.01878 14.75 5.5C14.75 3.98122 13.5188 2.75 12 2.75C10.4812 2.75 9.25 3.98122 9.25 5.5C9.25 7.01878 10.4812 8.25 12 8.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAnchor1;
